import React, {useEffect, useRef, useState} from 'react';
import {webInfo} from "../../../../utils/webInfo";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {FileUpload} from "primereact/fileupload";
import {InputTextarea} from "primereact/inputtextarea";
import {Dropdown} from "primereact/dropdown";
import callToast, {catchError, showErrors} from "../../../../utils/helper";
import usePost from "../../../../hooks/usePost";
import useApi from "../../../../hooks/useApi";
import {Skeleton} from "primereact/skeleton";
import {Toast} from "primereact/toast";
import {useNavigate} from "react-router-dom";
import TextEditor from "../../../../components/TextEditor";

const HerbalCreateForm = () => {
    const {post,loading:ploading} = usePost();
    const toast = useRef<any>(null);
    const {get, loading:gloading} = useApi<any>();
    const [categories,setCategories] = useState([]);
    const navigate = useNavigate();
    const [product, setProduct] = useState<any>({
        brand_name: "",
        product_name: "",
        health_benefit: "",
        indication: "",
        dosage: "",
        pack_size: "",
        image: "",
        images: [{id: 1, image: ""}],
        product_herbal_category_id:0,
        details_pdf: "",
        key_facts: [{id: 1, image: "", title: "", description: "",def:true}, {id: 2, image: "", title: "", description: "",def:true}],
        meta_title: "",
        meta_description: "",
        meta_robots: "",
        meta_author: "",
        meta_keywords: "",
    });

    const onUploadPdf = (event: any) => {
        setProduct({
            ...product,
            details_pdf: event.files[0],
        })
    };
    const onRemovePdf = () => {
        setProduct({
            ...product,
            details_pdf: "",
        })
    };

    const onUpload = (event: any) => {
        setProduct({
            ...product,
            image: event.files[0],
        })
    };
    const onRemove = () => {
        setProduct({
            ...product,
            image: ""
        })
    };
    const onMetaUpload = (event: any) => {
        setProduct({
            ...product,
            meta_image: event.files[0],
        })
    };
    const onMetaRemove = () => {
        setProduct({
            ...product,
            meta_image: "",
        })
    };

    useEffect(() => {
        const url = `${webInfo.baseUrl}/api/admin/products-herbal-category?page=1&per_page=1000`
        const fetchCategories = async () => {
            try {
                const res: any = await get(url);
                const cate = res.data.data?.map((item:any)=>{
                    return {
                        name: item?.name,
                        code: item?.id,
                    }
                })
                setCategories(cate);
            } catch (err) {
                console.error("Failed to fetch products", err);
            }
        };
        fetchCategories();
        // eslint-disable-next-line
    }, []);


    const selectKeyFactImage = (e: any, id: any) => {
        const key_fact: any = product?.key_facts?.map((item: any) => {
            if (item.id === id) {
                return {
                    ...item,
                    image: e.files[0]
                }
            }
            return item;
        });
        setProduct({
            ...product,
            key_facts: key_fact
        })
    }

    const handleKeyfact = (e: any, id: any) => {
        const key_fact: any = product?.key_facts?.map((item: any) => {
            if (item.id === id) {
                return {
                    ...item,
                    [e.target.name]: e.target.value
                }
            }
            return item;
        });
        setProduct({
            ...product,
            key_facts: key_fact
        })
    }

    const addProduct = async () => {
        const url = `${webInfo.baseUrl}/api/admin/products-herbal`;
        const formData = new FormData();
        const payload:any = {
            ...product,
        }
        // for (const key in payload) {
        //     const value = payload[key as keyof typeof payload];
        //     if (value !== null && value.length > 0) {
        //         if (key === "image" && typeof value === "string") continue;
        //         if (key === "meta_image" && typeof value === "string") continue;
        //         if (key === "key_facts") continue;
        //         if (key === "images") continue;
        //         formData.append(key, payload[key]);
        //     }
        // }
        for (const key in payload) {
            const value = payload[key as keyof typeof payload];
            if (value !== null) {
                // if (key === "image" && typeof value === "string") continue;
                // if (key === "meta_image" && typeof value === "string") continue;
                // if (key === "details_pdf" && typeof value === "string") continue;
                if (key === "key_facts") continue;
                if (key === "images") continue;
                formData.append(key, payload[key]);
            }

            if(key === "image" && typeof value !== "string" && value instanceof File){
                formData.append(key, value);
            }
            if(key === "meta_image" && typeof value !== "string" && value instanceof File){
                formData.append(key, value);
            }
            if(key === "details_pdf" && typeof value !== "string" && value instanceof File){
                formData.append(key, value);
            }
        }
        const validKeyFacts = (product.key_facts || []).filter((item: any) => {
            const hasTitle = typeof item?.title === "string" && item.title.trim().length > 0;
            const hasDescription = typeof item?.description === "string" && item.description.trim().length > 0;
            const hasImage = item?.image instanceof File;
            return hasTitle && hasDescription && hasImage;
        });

        validKeyFacts.forEach((item: any, index: number) => {
            formData.append(`key_facts[${index}][title]`, item.title.trim());
            formData.append(`key_facts[${index}][image]`, item.image);
            formData.append(`key_facts[${index}][description]`, item.description.trim());
        });
        // const key1 = product.key_facts[0]
        // const key2 = product.key_facts[1]
        // if (key1.title && key1.image && key1.description && key2.title && key2.image && key2.description) {
        //     product.key_facts.forEach((item: any,index:any) => {
        //         formData.append(`key_facts[${index}][title]`,item.title)
        //         formData.append(`key_facts[${index}][image]`,item.image)
        //         formData.append(`key_facts[${index}][description]`,item.description)
        //     })
        // }
        if (product.images[0].image) {
            product.images.forEach((item: any) => {
                formData.append(`images[]`,item.image)
            })
        }
        try {
            // @ts-ignore
            const res:any = await post(url,false,formData);
            if (res.success){
                callToast(toast,true,res.message)
                setTimeout(()=>{
                    navigate("/products-herbal")
                },500)
            }else {
                showErrors(res.error?.message || res.error,toast);
            }
        }catch (e) {
            catchError(e)
        }
    }

    const handleChange = (e: any) => {
        setProduct({
            ...product,
            [e.target.name]: e.target.value,
        })
    }


    return (
        <div>
            <Toast ref={toast} />
            <div className="grid">
                {/* LEFT SIDE – PRODUCT INFO (7 COLS) */}
                <div className="col-12 md:col-7">
                    <div className="pr-2">
                        <div className="p-fluid grid">
                            {/* Product Name */}
                            <div className="col-12 md:col-12">
                                <label className="font-medium">Brand Name *</label>
                                <InputText
                                    value={product.brand_name}
                                    onChange={(e) =>
                                        setProduct({...product, brand_name: e.target.value})
                                    }
                                    placeholder="Enter brand name"
                                />
                            </div>

                            {/* Brand */}

                            <div className="col-12 md:col-6">
                                <label className="font-medium">Product Name *</label>
                                <InputText
                                    value={product.product_name}
                                    onChange={(e) =>
                                        setProduct({...product, product_name: e.target.value})
                                    }
                                    placeholder="Enter product name"
                                />
                            </div>

                            <div className="col-12 md:col-6">
                                <label className="font-medium">Product Category *</label>
                                {!gloading ? <Dropdown
                                    value={categories?.find((item: any) => Number(item?.code) === Number(product.product_herbal_category_id))}
                                    options={categories}
                                    optionLabel="name"
                                    onChange={(e) =>
                                        setProduct({...product, product_herbal_category_id: e.value.code})
                                    }
                                    placeholder="Select Category"
                                    className="w-full"
                                />: <Skeleton height="3rem" className="w-full"></Skeleton>}
                            </div>

                            <div className="col-12">
                                <label className="font-medium">Product Image (686 x 357 || 1024 kB max) *</label>
                                <FileUpload
                                    name="demo[]"
                                    url="/api/upload"
                                    multiple={false}
                                    accept="image/*"
                                    maxFileSize={1024 * 1024}
                                    onSelect={onUpload}
                                    onRemove={onRemove}
                                />
                            </div>

                            <div className="col-12">
                                <div>
                                    <div className="flex justify-content-between w-full">
                                        <label className="font-medium">Multiple Images (686 x 357 || 1024 kB max / image)</label>
                                        <Button
                                            label="Add New"
                                            style={{width: 'fit-content'}}
                                            icon="pi pi-plus"
                                            onClick={() => {
                                                const newId = (product.images?.at(-1)?.id || 0) + 1;

                                                setProduct({
                                                    ...product,
                                                    images: [...product.images, {id: newId, image: ""}]
                                                });
                                            }}
                                        />
                                    </div>

                                    {product?.images?.map((item: any) => {

                                        const preview =
                                            typeof item.image === "string"
                                                ? item.image
                                                    ? `${webInfo.baseUrl}/${item.image}`
                                                    : webInfo.uploadImg
                                                : item.image
                                                    ? URL.createObjectURL(item.image)
                                                    : webInfo.uploadImg;

                                        return (
                                            <div key={item.id} className="flex align-items-center mb-3 gap-3">


                                                {/*{*/}
                                                {/*    preview && (*/}
                                                <img
                                                    src={preview}
                                                    alt="preview"
                                                    width="60"
                                                    height="60"
                                                    className='border border-2 border-gray-200'
                                                    style={{objectFit: "cover", borderRadius: "6px"}}
                                                />
                                                {/*)*/}
                                                {/*}*/}

                                                {/* uploader */}
                                                <FileUpload
                                                    mode="basic"
                                                    name="image"
                                                    accept="image/*"
                                                    maxFileSize={1024 * 1024}
                                                    auto={false}
                                                    chooseLabel="Select Image"
                                                    onSelect={(event: any) => {

                                                        const images = product.images.map((img: any) => {
                                                            if (img.id === item.id) {
                                                                return {
                                                                    ...img,
                                                                    image: event.files[0]
                                                                };
                                                            }
                                                            return img;
                                                        });

                                                        setProduct({
                                                            ...product,
                                                            images
                                                        });
                                                    }}
                                                />

                                                {/* remove */}
                                                <Button
                                                    icon="pi pi-trash"
                                                    severity="danger"
                                                    text
                                                    onClick={() => {
                                                        const filtered = product.images.filter(
                                                            (img: any) => img.id !== item.id
                                                        );

                                                        setProduct({
                                                            ...product,
                                                            images: filtered
                                                        });
                                                    }}
                                                />

                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            {/* Product PDF */}
                            <div className="col-12">
                                <label className="font-medium">Product PDF (10 mb max)</label>
                                <FileUpload
                                    name="demo[]"
                                    url="/api/upload"
                                    multiple={false}
                                    accept="application/pdf"
                                    maxFileSize={10 * 1024 * 1024}
                                    onSelect={onUploadPdf}
                                    onRemove={onRemovePdf}
                                />
                            </div>

                            <div className="col-12">
                                <label className="font-medium">Pack Size</label>
                                {/*<TinyEditor*/}
                                {/*    value={product?.pack_size}*/}
                                {/*    onChange={(content: string) =>*/}
                                {/*        setProduct((prev: any) => ({*/}
                                {/*            ...prev,*/}
                                {/*            pack_size: content*/}
                                {/*        }))*/}
                                {/*    }*/}
                                {/*/>*/}
                                <TextEditor
                                    value={product?.pack_size || ''}
                                    setValue={(content: string) =>
                                        setProduct((prev: any) => ({
                                            ...prev,
                                            pack_size: content,
                                        }))
                                    }
                                />
                            </div>
                            <div className="col-12">
                                <label className="font-medium">Health Benefit</label>
                                {/*<TinyEditor*/}
                                {/*    value={product?.health_benefit}*/}
                                {/*    onChange={(content: string) =>*/}
                                {/*        setProduct((prev: any) => ({*/}
                                {/*            ...prev,*/}
                                {/*            health_benefit: content*/}
                                {/*        }))*/}
                                {/*    }*/}
                                {/*/>*/}
                                <TextEditor
                                    value={product?.health_benefit || ''}
                                    setValue={(content: string) =>
                                        setProduct((prev: any) => ({
                                            ...prev,
                                            health_benefit: content,
                                        }))
                                    }
                                />
                            </div>
                            <div className="col-12">
                                <label className="font-medium">Composition</label>
                                {/*<TinyEditor*/}
                                {/*    value={product?.composition}*/}
                                {/*    onChange={(content: string) =>*/}
                                {/*        setProduct((prev: any) => ({*/}
                                {/*            ...prev,*/}
                                {/*            composition: content*/}
                                {/*        }))*/}
                                {/*    }*/}
                                {/*/>*/}
                                <TextEditor
                                    value={product?.composition || ''}
                                    setValue={(content: string) =>
                                        setProduct((prev: any) => ({
                                            ...prev,
                                            composition: content,
                                        }))
                                    }
                                />
                            </div>
                            <div className="col-12">
                                <label className="font-medium">Indication</label>
                                {/*<TinyEditor*/}
                                {/*    value={product?.indication}*/}
                                {/*    onChange={(content: string) =>*/}
                                {/*        setProduct((prev: any) => ({*/}
                                {/*            ...prev,*/}
                                {/*            indication: content*/}
                                {/*        }))*/}
                                {/*    }*/}
                                {/*/>*/}
                                <TextEditor
                                    value={product?.indication || ''}
                                    setValue={(content: string) =>
                                        setProduct((prev: any) => ({
                                            ...prev,
                                            indication: content,
                                        }))
                                    }
                                />
                            </div>
                            <div className="col-12">
                                <label className="font-medium">Dosage & Administration</label>
                                {/*<TinyEditor*/}
                                {/*    value={product?.dosage}*/}
                                {/*    onChange={(content: string) =>*/}
                                {/*        setProduct((prev: any) => ({*/}
                                {/*            ...prev,*/}
                                {/*            dosage: content*/}
                                {/*        }))*/}
                                {/*    }*/}
                                {/*/>*/}
                                <TextEditor
                                    value={product?.dosage || ''}
                                    setValue={(content: string) =>
                                        setProduct((prev: any) => ({
                                            ...prev,
                                            dosage: content,
                                        }))
                                    }
                                />
                            </div>

                        </div>
                    </div>
                </div>

                {/* RIGHT SIDE – SEO INFO (5 COLS) */}
                <div className="col-12 md:col-5">

                    <div className="pl-2">
                        {
                            product?.key_facts?.map((fact: any, index: any) => {
                                const img_type = typeof fact.image
                                // const objectUrl = img_type === 'string' ? `${webInfo.baseUrl}/${fact?.image}` : URL.createObjectURL(fact.image);
                                const objectUrl = img_type === 'string' ? (fact.def ? `${webInfo.uploadImg}` :`${webInfo.baseUrl}/${fact?.image}`) : URL.createObjectURL(fact.image);
                                return <div className="mb-3" key={fact.id}>
                                    <label className="font-medium">Key Insides 0{index + 1} (47 x 47 for Image)</label><br/>
                                    <div className="flex align-items-center">
                                        <div className="border-2 border border-gray-400 overflow-hidden "
                                             style={{height: '50px', width: '50px', borderRadius: '5px'}}>
                                            <img
                                                alt="Default"
                                                src={objectUrl} className="object-cover h-full w-full"/>
                                        </div>
                                        <FileUpload className="ml-2" mode="basic" name="demo[]" url="/api/upload"
                                                    accept="image/*" onSelect={(e) => selectKeyFactImage(e, fact.id)}/>
                                    </div>
                                    <div className="my-2">
                                        <InputText name={'title'} onChange={(e: any) => handleKeyfact(e, fact.id)}
                                                   value={fact?.title} className="w-full"
                                                   placeholder="Key Insides Title"/>
                                    </div>
                                    <div>
                                        <InputTextarea name={'description'}
                                                       onChange={(e: any) => handleKeyfact(e, fact.id)}
                                                       value={fact?.description} className="w-full"
                                                       placeholder="Key Insides Description"/>
                                    </div>
                                </div>
                            })
                        }

                        <div className="grid">
                            <div className="col-12">
                                <h4 className="mb-3">SEO Information</h4>
                            </div>

                            {/* Meta Title */}
                            <div className="col-12">
                                <label className="font-medium">Meta Title</label>
                                <InputText
                                    name="meta_title"
                                    value={product.meta_title || ""}
                                    onChange={handleChange}
                                    placeholder="Meta Title"
                                    className="w-full"
                                />
                            </div>

                            {/* Meta Author */}
                            <div className="col-12 md:col-6">
                                <label className="font-medium">Meta Author</label>
                                <InputText
                                    name="meta_author"
                                    value={product.meta_author || ""}
                                    onChange={handleChange}
                                    placeholder="Meta Author"
                                    className="w-full"
                                />
                            </div>

                            {/* Meta Robots */}
                            <div className="col-12 md:col-6">
                                <label className="font-medium">Meta Robots</label>
                                <Dropdown
                                    value={product.meta_robots || ""}
                                    options={[
                                        {label: "Index, Follow", value: "index, follow"},
                                        {label: "No Index, Follow", value: "noindex, follow"},
                                        {label: "Index, No Follow", value: "index, nofollow"},
                                        {label: "No Index, No Follow", value: "noindex, nofollow"}
                                    ]}
                                    onChange={(e) =>
                                        setProduct({...product, meta_robots: e.value})
                                    }
                                    placeholder="Select Robots Option"
                                    className="w-full"
                                />
                            </div>

                            {/* Meta Description */}
                            <div className="col-12">
                                <label className="font-medium">Meta Description</label>
                                <InputTextarea
                                    name="meta_description"
                                    value={product.meta_description || ""}
                                    onChange={handleChange}
                                    rows={4}
                                    placeholder="Meta Description"
                                    className="w-full"
                                    autoResize
                                />
                            </div>

                            {/* Meta Keywords */}
                            <div className="col-12">
                                <label className="font-medium">Meta Keywords</label>
                                <InputText
                                    name="meta_keywords"
                                    value={product.meta_keywords || ""}
                                    onChange={handleChange}
                                    placeholder="keyword1, keyword2, keyword3"
                                    className="w-full"
                                />
                            </div>


                            {/* Meta Image Upload */}
                            <div className="col-12">
                                <label className="font-medium">Meta Image (686 x 357 || 1024 kB max)</label>
                                <FileUpload
                                    name="demo[]"
                                    url="/api/upload"
                                    multiple={false}
                                    accept="image/*"
                                    maxFileSize={1024 * 1024}
                                    // emptyTemplate={defaultMetaImagePreviewer}
                                    onSelect={onMetaUpload}
                                    onRemove={onMetaRemove}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* ACTION BUTTONS */}
                <div className="col-12 flex justify-content-end gap-2 mt-3">
                    <Button loading={ploading} onClick={addProduct} label="Add Product" icon="pi pi-check"/>
                </div>
            </div>
        </div>
    );
};

export default HerbalCreateForm;